import axios from 'axios'
import { baseUrl } from './config'

export function getMainURL () {
  return axios.get(`${baseUrl}/main-url`)
}

export function changeMainURL (newURL, cloudflare_settings) {
  return axios.put(`${baseUrl}/main-url`, {
    url: newURL,
    update_cloudflare_settings: cloudflare_settings
  })
}
